module.exports = __webpack_public_path__ + "static/Intro3dDemo-b6f88d9435bbae718c45af675dd5a52e.mp4";